var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPromotionIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 26,
    viewBox: "0 0 34 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H33.4286V26H0V15.8813H1.39347C2.13067 15.8813 2.83768 15.5778 3.35896 15.0374C3.88025 14.4971 4.1731 13.7642 4.1731 13C4.1731 12.2358 3.88025 11.5029 3.35896 10.9626C2.83768 10.4222 2.13067 10.1187 1.39347 10.1187H0V0ZM2.78693 2.88889V7.41349C3.74093 7.66921 4.62097 8.18527 5.32962 8.91984C6.37355 10.002 6.96003 11.4696 6.96003 13C6.96003 14.5304 6.37355 15.998 5.32962 17.0802C4.62097 17.8147 3.74093 18.3308 2.78693 18.5865V23.1111H30.6416V2.88889H2.78693Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9274 8.66667H11.1404V5.77778H13.9274V8.66667Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9274 14.4444H11.1404V11.5556H13.9274V14.4444Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9274 20.2222H11.1404V17.3333H13.9274V20.2222Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotionIcon);
export default __webpack_public_path__ + "static/media/promotionIcon.64a57f234450b44d6b97d8b371ce6dba.svg";
export { ForwardRef as ReactComponent };